import React from 'react';
import cn from '@utils/cn';
import Anchor from '../Anchor/Anchor';
import Text, { TextVariant } from '../Text/Text';

type DesignWrapperProps = {
  children: React.ReactNode;
  url?: string;
  name?: string;
  className?: string;
  description?: string;
};

export default function DesignWrapper({ children, name, description, url, className }: DesignWrapperProps) {
  return (
    <div className={cn('group select-none overflow-hidden', className)}>
      <Anchor href={url}>
        {children}
        {name && (
          <div className="p-2">
            <Text
              content={name}
              variant={TextVariant.TemplateTextSM}
              className={cn('decoration-foreground underline-offset-4 group-hover:underline', {
                'line-clamp-2 min-h-[2.625rem] lg:min-h-[3.3rem]': !description,
              })}
              title={name}
            />
            {description && (
              <Text
                content={description}
                variant={TextVariant.TemplateTextSM}
                className="whitespace-nowrap"
                title={description}
              />
            )}
          </div>
        )}
      </Anchor>
    </div>
  );
}
